import React, { useRef, useState } from "react";
import style from "../../css/homepage/Contactus.module.css";
import { API_BASE_URL } from "../ApiConfig";
import { showCustomAlert } from "../customalert";
import { getSecureToken } from "../ApisService/apiService";

const ContactUs = () => {
  const sectionRef = useRef(null);
  const formRef = useRef(null);
  const contentRef = useRef(null);
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", message: "", botTrap: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  const { secrettoken, ts } = await getSecureToken();

  const response = await fetch(`${API_BASE_URL}Contact_us/contact_form.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-TOKEN": secrettoken,
      "X-TIMESTAMP": ts,
    },
    credentials: "include", // This is equivalent to withCredentials: true in axios
    body: JSON.stringify(formData),
  });

  const result = await response.json();
  showCustomAlert(result.message);

  if (result.status === "success") {
    setFormData({ name: "", email: "", phone: "", message: "", botTrap: "" });
  }
};


  return (
    <div className={`container ${style.contact_container}`} ref={sectionRef}>
      <div className={`row ${style.contactus__row}`}>
        <div className={`col-md-6 ${style.contactus__right}`} ref={formRef}>
          <div className={style.contactus_title}>
            <h2 className={style.row__sub}>Feel free to ask any questions</h2>
          </div>
          <form id="contact" className={style.form} onSubmit={handleSubmit}>
            <div className={style.form_group}>

              <input
                type="text"
                name="botTrap"
                style={{ display: 'none' }}
                value={formData.botTrap || ''}
                onChange={handleChange}

              />
              <div className={style.form__field_half}>
                <input
                  type="text"
                  name="name"
                  placeholder="Name*"
                  className={style.form__field}
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className={style.form_group}>
              <div className={style.form__field_half}>
                <input
                  type="email"
                  name="email"
                  placeholder="Email address*"
                  className={style.form__field}
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className={style.form__field_half}>
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone number"
                  className={style.form__field}
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className={style.form_group}>
              <div className={style.form__field_half}>
                <textarea
                  name="message"
                  className={`form-control ${style.form__field}`}
                  rows="6"
                  placeholder="Your message*"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <button className={style.contactus_btn} type="submit">
                Submit
              </button>
            </div>
          </form>
        </div>

        <div className={`${style.contactus__section} col-md-6`} ref={contentRef}>
          <div className={style.contactus__content}>
            <h1 className={style.contactus__title}>
              GET IN <span className={style.highlight_gold}>TOUCH</span>
            </h1>
            <a href="#" className={style.brand}>
              SWING<span className={style.highlight_gold}>ALGO</span>
            </a>
            <div className={style.contact__details}>
              {/* <p>
                <i className="fa-solid fa-phone"></i>{" "}
                <a href="tel:+1234567890">8989518940</a>
              </p> */}
              <p>
                <i className="fa-solid fa-envelope"></i>{" "}
                <a href="mailto:info@stockexploder.io">support@swingalgo.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
